<template>
  <div>
    <el-form ref="form" size="mini" :model="data" status-icon :rules="formRules">
      <el-row class="item-title">
        <el-col :span="24">
          <span>进销单据和收付款单据的钩账方式</span>
        </el-col>
      </el-row>
      <el-row class="item-content">
        <el-col :span="24">
          <el-form-item prop="checkWay">
            <el-radio-group v-model="data.checkWay">
              <el-radio label="0">按单据</el-radio>
              <el-radio label="1">按明细</el-radio>
              <el-radio label="2">按余额</el-radio>
            </el-radio-group>
          </el-form-item>
          <span style="margin:0;">（选择</span>
          <span style="color:#FF8100;margin:0;">按单据</span>
          <span style="margin:0;">，则记录收的哪一笔单的款；选择</span>
          <span style="color:#FF8100;margin:0;">按明细</span>
          <span style="margin:0;">，则记录收的哪个商品的款；选择</span>
          <span style="color:#FF8100;margin:0;">按余额</span>
          <span style="margin:0;">，则只记录收的哪个客户的款）</span>
        </el-col>
      </el-row>
      <el-row class="item-title">
        <el-col :span="24">
          <span>单据和收付款的核销规则</span>
        </el-col>
      </el-row>
      <el-row class="item-content">
        <el-col :span="24">
          <el-form-item prop="writeOff">
            <el-radio-group v-model="data.writeOff">
              <el-radio label="0">按订单号核销</el-radio>
              <el-radio label="1">按往来单位核销</el-radio>
            </el-radio-group>
          </el-form-item>
          <span style="margin:0;">（选择</span>
          <span style="color:#FF8100;margin:0;">按订单号核销</span>
          <span style="margin:0;">，则收付款单和应收应付单核销必须订单号一致；选择</span>
          <span style="color:#FF8100;margin:0;">按往来单位核销</span>
          <span style="margin:0;">，则往来单位名称必须一致）</span>
        </el-col>
      </el-row>
      <el-row class="item-title">
        <el-col :span="24">
          <span>数据核销模式</span>
        </el-col>
      </el-row>
      <el-row class="item-content">
        <el-col :span="24">
          <el-form-item prop="writeOffMode">
            <el-radio-group v-model="data.writeOffMode">
              <el-radio label="0">自动</el-radio>
              <el-radio label="1">手动</el-radio>
            </el-radio-group>
          </el-form-item>
          <span style="margin:0;">（选择</span>
          <span style="color:#FF8100;margin:0;">自动</span>
          <span style="margin:0;">，每晚23:00系统自动核销）</span>
        </el-col>
      </el-row>
    </el-form>
    <el-alert title="数据保存成功后，需要重新登录才能生效" type="warning" :closable="false" />
    <div class="item-footer">
      <el-button type="primary" size="mini" style="width:80px;" @click="submit">保 存</el-button>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      data: {
        checkWayId: 0,
        checkWay: null, //进销单据和收付款单据的钩账方式
        writeOffId: 0,
        writeOff: null, //单据和收付款的核销规则
        writeOffModeId: 0,
        writeOffMode: null, //数据核销模式
      },
      isNull: false,
      saveData: [],
      formRules: {
        checkWay: [{ required: true, message: "请选择" }],
        writeOff: [{ required: true, message: "请选择" }],
        writeOffMode: [{ required: true, message: "请选择" }],
      },
      api: require("@/api/sy/opt").default,
    };
  },
  methods: {
    getData() {
      this.api.list({ Code: "CAPITAL" }).then((res) => {
        
        if (res.Data.length == 0) {
          this.isNull = true;
        }
        res.Data.forEach((item) => {
          switch (item.OptText) {
            case "CheckWay":
              this.data.checkWayId = item.OptId;
              this.data.checkWay = item.OptValue;
              break;
            case "WriteOff":
              this.data.writeOffId = item.OptId;
              this.data.writeOff = item.OptValue;
              break;
            case "WriteOffMode":
              this.data.writeOffModeId = item.OptId;
              this.data.writeOffMode = item.OptValue;
              break;
          }
        });
      });
    },
    submit() {
      let form = this.formValidate();
      form.then((valid) => {
        if (!valid) return;
        this.saveData = [];

        this.saveData.push({
          OptId: this.data.checkWayId,
          Code: "CAPITAL",
          OptValue: this.data.checkWay,
          OptText: "CheckWay",
        });
        this.saveData.push({
          OptId: this.data.writeOffId,
          Code: "CAPITAL",
          OptValue: this.data.writeOff,
          OptText: "WriteOff",
        });
        this.saveData.push({
          OptId: this.data.writeOffModeId,
          Code: "CAPITAL",
          OptValue: this.data.writeOffMode,
          OptText: "WriteOffMode",
        });

        if (this.isNull) {
          this.api.save(this.saveData).then((res) => {
            if (res.Code == 1) {
              this.$message.error(res.Msg);
            } else {
              this.isNull = false;
              this.$message.success("保存成功");
            }
          });
        } else {
          this.api.update(this.saveData).then((res) => {
            if (res.Code == 1) {
              this.$message.error(res.Msg);
            } else {
              this.$message.success("保存成功");
            }
          });
        }
      });
    },
    formValidate() {
      return this.$refs.form
        .validate()
        .then((valid) => {
          return valid;
        })
        .catch(() => {
          this.$notify({
            title: "提示",
            message: "请检查相关字段（红色）填写是否规范",
            type: "warning",
            position: "top-left",
          });
          return false;
        });
    },
  },
};
</script>
<style lang="less" scoped>
.item-title {
  margin-bottom: 10px;
  span {
    font-size: 18px;
    color: #606266;
  }
}
.item-content {
  margin-bottom: 30px;
  span {
    font-size: 14px;
    line-height: 29px;
    float: left;
    margin-right: 12px;
    color: #606266;
  }
}
.item-footer {
  margin-top: 10px;
  padding: 10px 20px 20px;
  text-align: center;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  border-top: 1px solid #e4e7ed;
}
.el-alert {
  padding-left: 5px;
  background: #cae2ff;
  color: #606266;
}
.el-form {
  padding: 0px 13px;
}
.el-form-item--mini.el-form-item,
.el-form-item--small.el-form-item {
  margin-bottom: 0px;
  margin-right: 40px;
  float: left;
}
</style>